const TABLE_STATE_SUFFIXES = [
  '-tableColumnVisibility',
  '-tableColumnOrder',
  '-tableColumnPinned',
  '-tableColumnSizing',
  '-tableSorting',
] as const;

const TABLE_SESSION_STATE_SUFFIXES = ['-columnSelectorCustomFieldsExpanded'] as const;

/**
 * Removes all table-related localStorage keys (column visibility, order, pinning, sizing, sorting)
 * and sessionStorage keys (column selector Custom Fields expand/collapse state).
 */
export const clearTableStateStorage = (): void => {
  if (typeof localStorage !== 'undefined') {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && TABLE_STATE_SUFFIXES.some(suffix => key.endsWith(suffix))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }

  if (typeof sessionStorage !== 'undefined') {
    const sessionKeysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && TABLE_SESSION_STATE_SUFFIXES.some(suffix => key.endsWith(suffix))) {
        sessionKeysToRemove.push(key);
      }
    }
    sessionKeysToRemove.forEach(key => sessionStorage.removeItem(key));
  }
};
